/** @format */
import { Link } from "react-router-dom";
import { LI } from "../../../AbstractElements";

export default function VideosNav() {
  return (
    <LI className="" title="Videos">
      <Link to="/videos-list">
        <i className="fa fa-play"></i>
      </Link>
    </LI>
  );
}
